import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BORDER_GRAY, DARK_GRAY } from 'constants/colors';
export default makeStyles(theme => {
  return createStyles({
    addressItem: {
      display: 'flex',
      flexDirection: 'column',
      border: `1px solid ${BORDER_GRAY}`,
      padding: theme.spacing(5, 3, 0, 3),
      margin: theme.spacing(3, 0),
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2)
      }
    },
    actionButton: {
      margin: theme.spacing(3, 1, 2, 0)
    },
    addressButtons: {
      alignSelf: 'flex-end'
    },
    addressButton: {
      display: 'flex'
    },
    standardAddress: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(2, 0, 0, 0),
      color: DARK_GRAY
    },
    addAddress: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      border: `1px solid ${BORDER_GRAY}`,
      padding: theme.spacing(2),
      marginBottom: theme.spacing(1.5)
    },
    dialogContent: {
      padding: theme.spacing(1)
    },
    mb2: {
      marginBottom: theme.spacing(2)
    },
    mt2: {
      marginTop: theme.spacing(2)
    }
  });
});